module.exports = __webpack_public_path__ + "img/windmill.4fde96d4.jpg";